import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { FloatInput, showToast } from "src/componentes";
import { CTeDto, getLocal, STORAGECTE_KEY, updateLocal } from "../CTe.Dto";
import { useNavigate } from "react-router-dom";
import { CTeExcluir, CTeFiltrar, CTeIncluir } from "src/services/Fiscal.Service";
import {
  MapearErrosServidor,
  MapearErrosServidorCampo,
} from "src/hook/Functions";
import moment from "moment";
import { showMessageBox } from "src/componentes/MessageBox/Messagebox";
import { FinalizacaoFormType, FinalizacaoSchema } from "./CTe.Cadastro.Dto";

const CTeCadastroFinalizacaoView = () => {
  const navigate = useNavigate();
  const cte = getLocal<CTeDto>(STORAGECTE_KEY);

  const form = useForm<FinalizacaoFormType>({
    resolver: yupResolver(FinalizacaoSchema),
    defaultValues: {
      emissaoDataHora: cte?.emissaoDataHora
        ? moment(cte.emissaoDataHora).format("DD/MM/YYYY HH:mm:ss")
        : moment().format("DD/MM/YYYY HH:mm:ss"),
      serie: cte?.serie ?? 1,
      numeroCte: cte?.numeroCte ?? 0,
      observacao: cte?.complemento?.observacao ?? "",
    },
  });

  const handleVoltar = () => {
    navigate("../documentos");
  };

  const handleConfirmar = async (data: FinalizacaoFormType) => {
    const formattedEmissao = moment(
      data.emissaoDataHora,
      "DD/MM/YYYY HH:mm:ss"
    ).format("YYYY-MM-DDTHH:mm:ss");

    updateLocal<CTeDto>(STORAGECTE_KEY, {
      emissaoDataHora: formattedEmissao,
      serie: Number(data.serie),
      numeroCte: Number(data.numeroCte || 0),
      complemento: {
        observacao: data.observacao || "",
      },
    });

    const cteFinal = getLocal<CTeDto>(STORAGECTE_KEY);
    if (!cteFinal) {
      showToast({
        message: "Dados do CT-e não encontrados no armazenamento",
        title: "Erro",
        variant: "Danger",
      });
      return;
    }

    showToast({
      message: "Processando inclusão do CT-e...",
      title: "Em cadastro",
      variant: "Info",
    });

    if (cteFinal.id && cteFinal.id > 0) {
      try {
        const cteExiste = await CTeFiltrar({ id: cteFinal.id });
        if (cteExiste.data.success && cteExiste.data.data.length > 0) {
          const responseExclusao = await CTeExcluir(cteFinal.id);
          if (!responseExclusao.data.success) {
            MapearErrosServidor(responseExclusao.data.notifications, showToast);
            return;
          }
        }
      } catch (error) {
        console.error("Erro ao verificar/substituir CT-e existente:", error);
      }
    }

    try {
      const response = await CTeIncluir(cteFinal);

      if (response.data.success) {
        showToast({
          message: "CT-e incluído com sucesso!",
          title: "Sucesso",
          variant: "Success",
        });
        updateLocal<CTeDto>(STORAGECTE_KEY, null);
        navigate("/fiscal/cte");
      } else {
        const notifications = response.data.notifications || [];
        notifications.forEach((item: any) => {
          if (item.key) {
            item.key = item.key.replace("Complemento.", "");
          }
        });

        MapearErrosServidorCampo(notifications, form.setError);
        notifications.forEach((item: any) => {
          showToast({
            message: `${item.key ? item.key + ": " : ""}${item.message}`,
            title: "Erro",
            variant: "Danger",
          });
        });
      }
    } catch (error) {
      console.error("Erro ao incluir CT-e:", error);
      showToast({
        message: "Ocorreu erro ao comunicar com o servidor",
        title: "Erro",
        variant: "Danger",
      });
    }
  };

  const onSubmit = async (data: FinalizacaoFormType) => {
    showMessageBox(
      "Deseja confirmar a emissão do CT-e?",
      "Atenção!",
      "YesNo",
      "Question",
      {
        onYes: async () => {
          await handleConfirmar(data);
        },
      }
    );
  };

  return (
    <Form noValidate onSubmit={form.handleSubmit(onSubmit)} className="mt-3 mb-5">
      <h5 className="mb-3 text-primary">Finalização e Emissão do CT-e</h5>
      <Row className="g-3">
        <Col xs={12} md={6}>
          <FloatInput
            label="Data e Hora de Emissão"
            inputMask="datahora"
            registerField={form.register("emissaoDataHora")}
            errorsMessage={form.formState.errors.emissaoDataHora}
          />
        </Col>
        <Col xs={6} md={3}>
          <FloatInput
            label="Série"
            inputMask="int"
            registerField={form.register("serie", { valueAsNumber: true })}
            errorsMessage={form.formState.errors.serie}
          />
        </Col>
        <Col xs={6} md={3}>
          <FloatInput
            label="Número CT-e"
            inputMask="int"
            registerField={form.register("numeroCte", { valueAsNumber: true })}
            errorsMessage={form.formState.errors.numeroCte}
          />
        </Col>
        <Col xs={12}>
          <FloatInput
            label="Observações / Informações Complementares"
            inputMask="textarea"
            maxLength={2000}
            registerField={form.register("observacao")}
            errorsMessage={form.formState.errors.observacao}
          />
        </Col>
      </Row>

      <div className="fixed-bottom">
        <Container className="py-3">
          <Row>
            <Col xs={6} className="d-grid">
              <Button variant="outline-secondary" onClick={handleVoltar}>
                Voltar
              </Button>
            </Col>
            <Col xs={6} className="d-grid">
              <Button variant="success" type="submit">
                Confirmar e Salvar CT-e
              </Button>
            </Col>
          </Row>
        </Container>
      </div>
    </Form>
  );
};

export default CTeCadastroFinalizacaoView;
